(function () {
  function isMobileStoryModal() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function clearMobileStoryModal(section) {
    var host = section.querySelector('[data-gnr-story-modal]');
    if (host) host.innerHTML = '';
  }

  function renderMobileStoryModal(section, story) {
    var host = section.querySelector('[data-gnr-story-modal]');
    if (!host) return;

    host.innerHTML = '';
    var clone = story.cloneNode(true);
    clone.classList.add('gnr26-story--modal');
    clone.dataset.expanded = 'true';
    clone.removeAttribute('data-gnr-story');
    clone.removeAttribute('data-modal-open');
    clone.setAttribute('role', 'dialog');
    clone.setAttribute('aria-modal', 'true');

    var cloneToggle = clone.querySelector('[data-gnr-story-toggle]');
    if (cloneToggle) {
      cloneToggle.removeAttribute('data-gnr-bound');
      cloneToggle.setAttribute('aria-expanded', 'true');
      cloneToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        collapseStories(section);
      });
    }

    host.appendChild(clone);
  }

  function syncStoryOverlay(section) {
    var openStory = section.querySelector('[data-gnr-story][data-modal-open="true"]');
    var useModal = isMobileStoryModal() && !!openStory;

    section.classList.toggle('is-story-open', useModal);
    document.documentElement.classList.toggle('gnr26-story-modal-open', useModal);

    if (useModal) {
      renderMobileStoryModal(section, openStory);
    } else {
      clearMobileStoryModal(section);
    }
  }

  function collapseStories(section, exceptStory) {
    section.querySelectorAll('[data-gnr-story]').forEach(function (story) {
      if (exceptStory && story === exceptStory) return;
      setStoryExpanded(section, story, false, true);
    });
    syncStoryOverlay(section);
  }

  function setStoryExpanded(section, story, expanded, skipOverlaySync) {
    var toggle = story.querySelector('[data-gnr-story-toggle]');
    var name = story.querySelector('.gnr26-story__name');
    var nameText = name ? name.textContent.trim() : '';
    var useModal = isMobileStoryModal();

    if (useModal) {
      story.dataset.expanded = 'false';
      story.dataset.modalOpen = expanded ? 'true' : 'false';
      story.removeAttribute('role');
      story.removeAttribute('aria-modal');
    } else {
      story.dataset.expanded = expanded ? 'true' : 'false';
      story.dataset.modalOpen = 'false';
      story.removeAttribute('role');
      story.removeAttribute('aria-modal');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var expandSetting = section.getAttribute('data-expand-label') || 'Expand story';
      var collapseSetting = section.getAttribute('data-collapse-label') || 'Collapse story';
      var label = (expanded ? collapseSetting : expandSetting) + (nameText ? ': ' + nameText : '');
      toggle.setAttribute('aria-label', label);
    }

    if (!skipOverlaySync) syncStoryOverlay(section);
  }

  function initStoryToggles(section) {
    section.querySelectorAll('[data-gnr-story]').forEach(function (story) {
      var toggle = story.querySelector('[data-gnr-story-toggle]');
      if (!toggle || toggle.dataset.gnrBound === 'true') return;

      toggle.dataset.gnrBound = 'true';
      toggle.addEventListener('click', function () {
        var isOpen = isMobileStoryModal()
          ? story.dataset.modalOpen === 'true'
          : story.dataset.expanded === 'true';
        var willExpand = !isOpen;
        if (willExpand) {
          collapseStories(section, story);
        }
        setStoryExpanded(section, story, willExpand);
      });
    });

    var backdrop = section.querySelector('[data-gnr-story-backdrop]');
    if (backdrop && backdrop.dataset.gnrBound !== 'true') {
      backdrop.dataset.gnrBound = 'true';
      backdrop.addEventListener('click', function () {
        collapseStories(section);
      });
    }

    if (section.dataset.gnrStoryEscBound !== 'true') {
      section.dataset.gnrStoryEscBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!section.classList.contains('is-story-open')) return;
        collapseStories(section);
      });
    }
  }

  function setActiveTab(section, tabName) {
    section.querySelectorAll('[data-gnr-tab]').forEach(function (tab) {
      var isActive = tab.dataset.gnrTab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('[data-gnr-panel]').forEach(function (panel) {
      var isActive = panel.dataset.gnrPanel === tabName;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (tabName !== 'hub') {
      collapseStories(section);
    }

    if (tabName !== 'booth') {
      closeHotspots(section);
    }
  }

  function initTabs(section) {
    section.querySelectorAll('[data-gnr-tab]').forEach(function (tab) {
      if (tab.dataset.gnrBound === 'true') return;
      tab.dataset.gnrBound = 'true';

      tab.addEventListener('click', function () {
        setActiveTab(section, tab.dataset.gnrTab);
      });
    });
  }

  function closeHotspots(section, exceptHotspot) {
    section.querySelectorAll('[data-gnr-hotspot]').forEach(function (hotspot) {
      if (exceptHotspot && hotspot === exceptHotspot) return;
      setHotspotOpen(hotspot, false);
    });
  }

  function setHotspotOpen(hotspot, open) {
    var toggle = hotspot.querySelector('[data-gnr-hotspot-toggle]');
    hotspot.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initHotspots(section) {
    section.querySelectorAll('[data-gnr-hotspot]').forEach(function (hotspot) {
      var toggle = hotspot.querySelector('[data-gnr-hotspot-toggle]');
      if (!toggle || toggle.dataset.gnrBound === 'true') return;
      toggle.dataset.gnrBound = 'true';

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = !hotspot.classList.contains('is-open');
        if (willOpen) {
          closeHotspots(section, hotspot);
        }
        setHotspotOpen(hotspot, willOpen);
      });
    });

    if (section.dataset.gnrHotspotDocBound === 'true') return;
    section.dataset.gnrHotspotDocBound = 'true';

    // Shrink the enlarged bubble when clicking empty map area.
    document.addEventListener('click', function (event) {
      var map = section.querySelector('[data-gnr-map]');
      if (!map || !map.contains(event.target)) return;
      if (event.target.closest('[data-gnr-hotspot]')) return;
      closeHotspots(section);
    });
  }

  function initCommunitySection(section) {
    if (!section || section.dataset.gnrCommunityReady === 'true') return;

    initTabs(section);
    initStoryToggles(section);
    initHotspots(section);
    section.dataset.gnrCommunityReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-gnr-community]').forEach(initCommunitySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-gnr-community]') || event.target;
    if (section.matches && section.matches('[data-gnr-community]')) {
      delete section.dataset.gnrCommunityReady;
      initCommunitySection(section);
    }
  });
})();
